import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const LocationMapping = () => {
    const data = {
        labels: ["Rajasthan", "Gujarat", "Maharashtra"],
        datasets: [
            {
                data: [45, 25, 30], // Percentage or values
                backgroundColor: ["#e74c3c", "#f39c12", "#f1c40f"],
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "top",
            },
        },
    };

    return (
        <div className="review-box margin-not_working">
            <div style={{ width: "180px", height: "auto", margin: "auto" }}>
                <Pie data={data} options={options} />
            </div>
        </div>
    );
};

export default LocationMapping;
